/* This is the EMIS Pre Internal toys components */

<template>
  <v-container>
    <div>
      <span v-html="title"></span>
    </div>
    <div>
      <table style="height: 61px" border="1px;" cellspacing="0px;">
        <tbody>
          <tr>
            <td
              style="
                width: 250px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              ប្រភេទ
            </td>
            <td
              style="
                width: 90px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              កម្រិតទាប
            </td>
            <td
              style="
                width: 90px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              កម្រិតមធ្យម
            </td>
            <td
              style="
                width: 90px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              កម្រិតខ្ពស់
            </td>
            <td
              style="
                width: 90px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              ថ្នាក់ចម្រុះ
            </td>
          </tr>
          <tr v-for="(value, row) in c2.length" :key="row" style="height: 25px">
            <td
              style="
                width: 150px;
                height: 25px;
                text-align: left;
                vertical-align: middle;
              "
            >
              {{ c2[row] }}
            </td>
            <td
              style="
                width: 90px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <v-select
                v-model="data[row].dt[0]"
                :items="yesNo6"
                item-text="text"
                item-value="value"
                outline
                hide-details
                @keypress.native="onSelect($event, row, 0)"
                class="d-inline"
                style="width: 100px; height: 25px; font-size: 9px"
              >
              </v-select>
            </td>
            <td
              style="
                width: 90px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <v-select
                v-model="data[row].dt[1]"
                :items="yesNo6"
                item-text="text"
                item-value="value"
                outline
                hide-details
                @keypress.native="onSelect($event, row, 1)"
                class="d-inline"
                style="width: 100px; height: 25px; font-size: 9px"
              >
              </v-select>
            </td>
            <td
              style="
                width: 90px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <v-select
                v-model="data[row].dt[2]"
                :items="yesNo6"
                item-text="text"
                item-value="value"
                outline
                hide-details
                @keypress.native="onSelect($event, row, 2)"
                class="d-inline"
                style="width: 100px; height: 25px; font-size: 9px"
              >
              </v-select>
            </td>
            <td
              style="
                width: 90px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <v-select
                v-model="data[row].dt[3]"
                :items="yesNo6"
                item-text="text"
                item-value="value"
                outline
                hide-details
                @keypress.native="onSelect($event, row, 3)"
                class="d-inline"
                style="width: 100px; height: 25px; font-size: 9px"
              >
              </v-select>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import { yesNo6 } from "@/utils/ascf/commonConfig.js";
import { c2 } from "@/utils/ascf/preConfig.js";
export default {
  props: ["data", "title"],
  data() {
    return {
      c2: c2,
      yesNo6: yesNo6,
    };
  },
  methods: {
    onSelect: function (event, row, col) {
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 50) {
        this.data[row].dt[col] = charCode - 48;
        this.$forceUpdate();
      }
    },
  },
};
</script>

<style scoped>
.input-group--select >>> .input-group__selections__comma {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 12px;
  padding: 1px 1px 1px 0;
}
</style>